import React from 'react';
import { motion } from 'framer-motion';
export function PositioningStrip() {
  return <section className="py-20 sm:py-28 lg:py-36 bg-white border-t border-gray-100" data-id="element-186">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-188">
          <p className="text-2xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-[1.15] tracking-tight" data-id="element-189">
            La mejor app es la que{' '}
            <span className="text-blue-600" data-id="element-190">nadie tiene que aprender.</span>
          </p>
          <p className="mt-8 sm:mt-10 text-sm sm:text-base lg:text-lg text-gray-500 leading-relaxed max-w-xl mx-auto" data-id="element-191">
            Tu equipo sigue usando WhatsApp.
            <span className="block" data-id="element-192">
              Obra Digital trabaja invisible por detrás.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}